import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MssTooltip from '../../../common/MssTooltip';

function NavItem({ title, icon, isOpen, isActive, onClick, ariaLabel }) {
  return (
    <ListItem disableGutters sx={{ p: 0, display: 'block' }}>
      <ListItemButton
        id={'devNav__button_' + title.replace(' ', '')}
        onClick={onClick}
        aria-label={ariaLabel || title}
        className={'navButton' + (isActive ? ' active' : '')}
      >
        <ListItemIcon className="navIcon" sx={{ pt: isOpen ? 0 : 1, pb: isOpen ? 0 : 1 }}>
          {isOpen ? (
            <FontAwesomeIcon icon={icon} size="lg" fixedWidth />
          ) : (
            <MssTooltip title={title} placement="right">
              <FontAwesomeIcon icon={icon} size="lg" fixedWidth />
            </MssTooltip>
          )}
        </ListItemIcon>
        {isOpen && (
          <ListItemText
            disableTypography
            primary={<Typography className="navLabel">{title}</Typography>}
          />
        )}
      </ListItemButton>
    </ListItem>
  );
}

export default NavItem;
